// export const debug = (state) => state.debug;

export const extconf = (state) => state.extconf;
// export const counter = (state) => state.counter;
// export const csrfToken = (state) => state.extconf.csrfToken;
export const backendBaseUrl = (state) => state.extconf.backendBaseUrl;
// export const lang = (state) => state.extconf.lang;
